import React from 'react';
import { Alert, Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { retryRecruiterLanguage } from './index';
import { useRecruiterLanguageState } from './languageState';
import { CORE_NS } from './namespaces/core';

/** Stays visible during retries so a failed startup remains recoverable. */
export const RecruiterLanguageRecovery: React.FC = () => {
  const { t } = useTranslation(CORE_NS);
  const failure = useRecruiterLanguageState((state) => state.failure);
  const loading = useRecruiterLanguageState((state) => state.loading);
  if (!failure) return null;

  return (
    <Alert
      color='yellow'
      title={t('languageRecovery.title')}
      role='alert'
      flex='0 0 auto'
    >
      <Stack gap='xs'>
        <Text size='sm'>
          {t(
            failure === 'timeout'
              ? 'languageRecovery.timeout'
              : 'languageRecovery.unavailable'
          )}
        </Text>
        <Group>
          <Button
            size='xs'
            variant='outline'
            loading={loading}
            aria-busy={loading}
            onClick={() => void retryRecruiterLanguage()}
          >
            {t('actions.retry')}
          </Button>
        </Group>
      </Stack>
    </Alert>
  );
};
